"use client";

import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const steps = [{
  step: "01",
  title: "Assess",
  description: "Clinical or biomechanical assessment based on the individual question"
}, {
  step: "02",
  title: "Measure",
  description: "Objective movement information where it can add value"
}, {
  step: "03",
  title: "Plan",
  description: "Clear recommendations based on the combined findings"
}];
export default function CareProcess() {
  return <section id="careprocess" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="rounded-2xl md:rounded-3xl bg-primary text-primary-foreground p-8 sm:p-10 md:p-14 lg:p-16 shadow-xl">
          <div className="max-w-3xl">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight leading-tight">
              Clinical expertise with specialist biomechanics when useful
            </h2>
            <p className="mt-4 text-base sm:text-lg text-primary-foreground/90 leading-relaxed">
              Your history, symptoms and goals come first. Where additional
              measurement can provide useful information, PhysAnalytica can add
              pressure gait analysis, balance measurement or other specialist
              biomechanics.
            </p>
          </div>

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((item, index) => <motion.div key={item.step} data-index={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.45,
            delay: index * 0.1,
            ease: "easeOut"
          }} whileHover={{
            y: -4
          }}>
                <Card className="h-full bg-card text-card-foreground border-0 shadow-md transition-shadow hover:shadow-lg">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-xl font-bold tracking-tight">
                      <span className="text-primary mr-2 font-mono text-lg font-semibold">
                        {item.step}
                      </span>
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>)}
          </div>

          <div className="mt-10 md:mt-14 pt-8 border-t border-primary-foreground/15 text-center">
            <p className="text-sm sm:text-base font-medium text-primary-foreground/90">
              Technology supports professional assessment. It does not replace it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}